import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import * as R from 'ramda';
import { CommonServices, OtherService, PersonalServices, AssuranceOptions } from '../../../../../constants/utils/connectionTypes';
import {getUserConnections} from '../../../../../actions/facilita-api';

import { DemarchesCommunes } from './demarchesCommunes';
import { DemarchesPersonalisees } from './demarchesPersonalisees';
import { useDispatch } from 'react-redux';


export const Step2 = ({defaultPersonalData, isLoading, connectionTypes, setSubsectionsStatuses, subsectionsStatuses}) => {
  const dispatch = useDispatch();
  const [subStep, setSubStep] = useState(1);

  let initialState = Object.values({...CommonServices, ...PersonalServices, ...AssuranceOptions}).map(o => o.connectionType);
  if(connectionTypes.filter(c => c.connectionType !== OtherService.activity.connectionType && c.connectionType !== OtherService.pension.connectionType && c.connectionType !== OtherService.poleEmploi.connectionType && c.connectionType !== OtherService.otherActivity.connectionType && c.connectionType !== OtherService.locataire.connectionType  ).length > 0){
    initialState = connectionTypes.map(c => c.connectionType);
  }

  const [selectedUserConnection, setSelectedUserConnection] = useState(initialState);

  useEffect(() => {
    dispatch(getUserConnections(defaultPersonalData.id));
  }, [])


  useEffect(() => {
    if(subStep > 1){
      setSubsectionsStatuses({...subsectionsStatuses, demarchesPersonalisee: true});
    }
  }, [subStep])

  useEffect(() => {
    if(connectionTypes.filter(c => c.connectionType !== OtherService.activity.connectionType && c.connectionType !== OtherService.pension.connectionType && c.connectionType !== OtherService.poleEmploi.connectionType && c.connectionType !== OtherService.otherActivity.connectionType &&  c.connectionType !== OtherService.locataire.connectionType ).length === 0){
      setSelectedUserConnection(Object.values({...CommonServices, ...PersonalServices, ...AssuranceOptions}).map(o => o.connectionType));
    }else{
      setSelectedUserConnection(connectionTypes.map(c => c.connectionType));
    }
    
  }, [connectionTypes])

  if(subStep === 1){
    return (<DemarchesCommunes userId={defaultPersonalData.id} setSubStep={setSubStep} setSelectedUserConnection={setSelectedUserConnection} selectedUserConnection={selectedUserConnection} />);
  }else{
    return <DemarchesPersonalisees userId={defaultPersonalData.id} setSubStep={setSubStep} setSelectedUserConnection={setSelectedUserConnection} selectedUserConnection={selectedUserConnection} isLoading={isLoading} />
  }
}